export const WHAT_DRIVES_ME = {
  title: 'What drives me',
  content: `
    I believe that the web is meant to bring people together. It is the best tool we have to become more human.\n
    The web allows us to learn, communicate, connect and understand our world in awesome and unimaginable ways.\n
    For me, software development plays a big role in today's societies. That's why, for me, it’s important to work with people (and in projects) that remind me that we all can make a difference, no matter what we do, no matter who we are.`
};

export const WHAT_I_DO = {
  title: 'What I do',
  content: `
    I’m a React web developer that tries to represent ideas in an simple, interactive and visually appealing way.\n
    I’m curious about new technologies especially when they bring awesome experiences to the users of the websites I develop.\n
    You’ll find more about what I do in: (GitHub)[https://github.com/jmtov/] and (Codepen)[https://codepen.io/jmtov].
  `
}

export const HOW_I_WORK = {
  title: 'How I work',
  sections: [
    {
      id: 'a-web-for-everyone',
      title: 'A web for everyone',
      content: `
        The web should be a safe and comfortable place for everyone who browse it.\n
        Through my work, I try to make it clear that everyone who visits a website is welcomed. Using a neutral, rich and simple language that everyone can understand.
      `
    },
    {
      id: 'accessibility',
      title: 'Accessibility',
      content: `
        As of January 2020, more than 4 billion people browse the web. But not all of them use a keyboard, a pointing device or even a screen.\n
        A (huge number)[https://www.akeaweb.com/learn-about-web-accessibility/resources/accessibility-statistics/] of websites lack accessibility features leaving users with visual or any other physical impairment far behind.\n
        Making a website accessible from the very beginning will not only allow more people to navigate a website but will also ease the general user workflow making all the features available with little to no effort.\n
        It’s up to us to ensure that inequality is addressed in every single aspect of human interaction.
      `
    },
    {
      id: 'minimalism',
      title: 'Minimalism',
      content: `
        Even though cliché, I strongly believe that _less is more_.\n
        Building a website with minimalism in mind will lead to a content-driven simpler user workflow.\n
        Minimalism has a great impact in how the website is coded and maintained. Simple websites require less code. Less lines of code mean less energy needed to download, store and display something on the screen, which also means faster, more responsive and less cluttered information to be delivered.\n
        In other words, minimalism helps not only making a website look cool, but also helps the environment, and the overall user experience.
      `
    },
    {
      id: 'meaningful-experiences',
      title: 'Meaningful experiences',
      content: `
        A website is more than just text and images being displayed on a screen.\n
        Giving feedback to the user as they navigate a website is the key principle to make them feel like they’re needs are being addressed in every single click.\n
        For me, the use of microinteractions and subtle transitions enhance the overall user experience making the navigation of a website something natural and well-driven.
      `
    },
  ]
}

export const WHO_I_AM = {
  title: 'Who I am',
  content: `
    I’m Enrique Mejía, 25 years old. I was born in Bogotá, Colombia. Currently living somewhere in Buenos Aires, Argentina.\n
    I love animals, walks, techno, aerial silks, honesty and people who are true to themselves.\n
    I care about the environment and making the world better for everyone.
  `
}

export const CONTACT = {
  title: `Let's work together!`
}

const TEXTS = {
  WHAT_DRIVES_ME,
  WHAT_I_DO,
  HOW_I_WORK,
  WHO_I_AM,
  CONTACT,
}

export default TEXTS;
